<template lang="pug">
footer
    .container.mx-auto
        //transition(name="fade")
            div#to-top(@click="toTop" v-if="scY > 50")
                font-awesome-icon(icon="angle-up")

        .footer-wrap.container.mx-auto
            div.logo-address
                .logo
                    //- img(src="@/assets/logo_white.png")
                    h1 SELECT
            .address
                h4 SELECT MODEN
                p Mährstraße 11
                p 58329 Schwerte
                p Tel.: +49 (0) 2304 / 22 61 6
                p E-Mail: 
                  a(href="mailto:info@select-moden.de") info@select-moden.de
            Menu#footer-cat.menu(k="footer-menu" :max-depth="1")
            .payment-info 
                img(src="@/assets/payment.png")

</template>

<script>
import { mapGetters } from "vuex";

import Menu from "@/components/Menu.vue";

export default {
  name: "Footer",
  components: {
    Menu
  },
  data() {
    return {
      scTimer: 0,
      scY: 0
    };
  },
  computed: {
    ...mapGetters({
      menus: "menus",
      config: "config"
    })
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },

  methods: {
    handleScroll: function() {
      if (this.scTimer) return;
      this.scTimer = setTimeout(() => {
        this.scY = window.scrollY;
        clearTimeout(this.scTimer);
        this.scTimer = 0;
      }, 100);
    },
    toTop: function() {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }
  }
};
</script>

<style lang="sass" nolang="scss" scoped>
@import "~@/assets/sass/variables"

footer
  @apply hidden
  @screen lg
    @apply block bottom-0 w-full text-white
    background: $etori-sec
  h1
    font-size: 36px
    line-height: 36px
  .footer-wrap
    @apply flex relative font-light py-16 justify-around px-32
    > *
      @apply mr-16
    .logo-address
      .logo
        @apply pt-1
      .address
        @apply pt-4
        a
          &:hover
            text-decoration: underline!important
    #footer-info
      @apply mr-0
      columns: 2
      column-gap: 4em
    .payment-info > img
      @apply pt-1
      max-width: 260px
    .menu ::v-deep
      a
        @apply transition duration-200 ease-in-out
        &:hover
          color: $etori-base

  div#to-top
    @apply fixed w-8 h-8 leading-8 text-center transition duration-500 ease-in-out cursor-pointer bg-black bg-opacity-75
    bottom: 17px
    right: 17px
    z-index: 200
    &:hover
      background-color: $etori-sec
      outline: 1px solid #fff

  .fade-enter,
  .fade-leave-to
    @apply opacity-0

  .fade-enter-active,
  .fade-leave-active
    @apply transition-opacity duration-500
</style>
